import React, {Fragment, useState, useRef, useImperativeHandle} from 'react';
import DropdownCountries from "ui/DropdownCountries";
import UserInput from "ui/ReactUserInput";
import UserInputCheckbox from "ui/ReactUserInputCheckbox";
import ErrorDiv from "ui/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import FieldsetContainer from "root/Base/FieldsetContainer";
import BootstrapCol from "ui/BootstrapCol";

const AsylumStatusForm = React.forwardRef(({readOnly, displayErrors, child}, ref) =>
{
   const [isAsylumSeeker, setIsAsylumSeeker] = useState(+(child.asylum_status) !== 0)
   const [isEAL, setEAL] = useState(+(child.eal_flag) === 1)

   const dropdownValue = child.country_id === null ? null : {value: +(child.country_id)};

   const [countryOfOrigin, setcountryOfOrigin] = useState(dropdownValue);

   const checkboxEAL = useRef(null);
   const InputFirstLanguage = useRef(null);
   const InputPreferredLanguage = useRef(null);

   useImperativeHandle(ref, () => ({
      getFormData()
      {
         return getFormDataLocal();
      },
      formIsValid()
      {
         return formIsValidLocal();
      },
   }))

   const getFormDataLocal = () =>
   {
      return (
         {
            asylum_status: isAsylumSeeker ? 1 : 0,
            eal_flag: isEAL ? 1 : 0,
            country_id: isAsylumSeeker ? countryOfOrigin.value : null,
            first_language: isEAL ? InputFirstLanguage.current.getValue() : null,
            preferred_language: isEAL ? InputPreferredLanguage.current.getValue() : null
         }
      )
   }

   const formIsValidLocal = () =>
   {
      let valid = true;

      if (isEAL)
      {
         if (!InputFirstLanguage.current.isValid())
         {
            valid = false;
         }

         if (!InputPreferredLanguage.current.isValid())
         {
            valid = false;
         }
      }

      if (isAsylumSeeker && valid)
      {
         valid = isCountryOfOriginValid();
      }

      return valid;
   }

   const isCountryOfOriginValid = () =>
   {
      return countryOfOrigin === null ? false : true;
   }

   const handleOnChangeDropdown = (v) =>
   {
      setcountryOfOrigin(v);
   }

   const onChangeEAL = (v) =>
   {
      setEAL(v);
   }

   const onChangeAsylum = (v) =>
   {
      setIsAsylumSeeker(v);

      if (v === false)
      {
         setcountryOfOrigin(null);
      }
   }

   const isAsylumSection = () =>
   {
      return (<Fragment>
         <div key='as1' className='col-md-8'>
            <DropdownCountries
               onChange={handleOnChangeDropdown}
               name='DropdownSchool'
               label='Country of Origin'
               key='DropdownCountry'
               errorText='Please select a country'
               options={{isSearchable: true}}
               value={countryOfOrigin === null ? null : +(countryOfOrigin.value)}
               id='DropdownCountry'
               defaultClassName=''
               readOnly={readOnly}/>
            {isCountryOfOriginValid() === false && displayErrors === true &&
               <ErrorDiv errorText='Please select a Country Of Origin'/>}
         </div>
      </Fragment>)
   }

   const isEALSection = () =>
   {
      return (
         <Fragment>
            <div key='eal11' className='col-md-4'>
               <UserInput validation={{required: true, maxlen: 100}}
                          id='InputFirstLanguage'
                          name='InputFirstLanguage'
                          key='InputFirstLanguage'
                          ref={InputFirstLanguage}
                          labelText='First Language'
                          errorText='Please enter a first language'
                          value={child.first_language}
                          readOnly={readOnly}
                          displayErrors={displayErrors}/>
            </div>
            <div key='eal12' className='col-md-4'>
               <UserInput validation={{required: true, maxlen: 100}}
                          id='InputPreferredLanguage'
                          name='InputPreferredLanguage'
                          key='InputPreferredLanguage'
                          ref={InputPreferredLanguage}
                          labelText='Preferred Language'
                          errorText='Please enter a preferred language'
                          value={child.preferred_language}
                          readOnly={readOnly}
                          displayErrors={displayErrors}/>
            </div>
         </Fragment>
      )
   }

   return (
      <Fragment>
         <BootstrapRow>
            <BootstrapCol width={12}>
               <FieldsetContainer title='EAL'>
                  <BootstrapRow>

                     <div key='ck1' className='col-md-4'>
                        <UserInputCheckbox
                           readOnly={readOnly}
                           key='CheckBoxIsAsylumSeeker'
                           defaultValue={isAsylumSeeker}
                           onChange={onChangeAsylum}
                           label='UASC'/>
                     </div>
                     {isAsylumSeeker === true && isAsylumSection()}
                     {!(isAsylumSeeker === true) && <div key='as2' className='col-md-8'/>}
                  </BootstrapRow>
                  <BootstrapRow>
                     <div key='ck2' className='col-md-4'>
                        <UserInputCheckbox
                           readOnly={readOnly}
                           key='CheckboxEAL'
                           ref={checkboxEAL}
                           defaultValue={isEAL}
                           onChange={onChangeEAL}
                           label='English as an Additional Language?'/>
                     </div>
                     {isEAL === true && isEALSection()}
                     {!(isEAL === true) && <div key='eal12' className='col-md-8'/>}
                  </BootstrapRow>
               </FieldsetContainer>
            </BootstrapCol>
         </BootstrapRow>
      </Fragment>

   )
})

export default AsylumStatusForm;
